/**
 * @namespace hamac/signatures/paiements/sepa
 */
import Request from '~/utils/infra/base/request'
import { concatAll } from '~/utils/lib/core/prelude'

// Saves information about the payment about to be done by a user
// The payment takes three steps
// (1) -> signature page, creates the payment process and saves the user
//        data along the payment data to the store
//
// (2) -> sepa form page, reads store information and allows the user to edit some
//        information such as: titulaire_compte, iban, nom, prenom
//
// (3) -> sepa payment page, reads the store information without allowing user to edit
//        it, clears the store information once a payment is made
export const useStore_hamac_signatures_paiements_sepa = defineStore('hamac/signatures/paiements/sepa', {
  state: () => ({
    /** @type {import('~/stores/hamac/signatures/infos').Article} */
    // @ts-ignore: UNSAFE coerce (pseudo maybe pattern)
    pack: null,
    titulaire_compte: '',
    remise_sma: false,
    price: 0,
    reference: '',
    payment_id: '',
    mandate: null,
    code: null,
    id: null,
    iban: '',
    nom: '',
    email: '',
    prenom: ''
  }),
  actions: {
    /// Actions
    ///
    /**
     * @function createPayment
     * @param {{
     *    code: string;
     *    prenom: string;
     *    nom: string;
     *    email: string;
     *    iban: string;
     *    titulaire_compte: string;
     *    reference: string;
     *    remise_sma: boolean;
     *    article: string;
     * }} options
     * @return {Promise<void>}
     */
    createPayment({ code, prenom, nom, email, iban, titulaire_compte, reference, remise_sma, article }) {

      const route = concatAll([
        `/paiements`,
        `/code/${code}`,
        `/sepa`,
      ])

      const request = new Request({
        method: 'post',
        route,
        data: {
          firstName: prenom,
          lastName: nom,
          email: email,
          article,
          iban: iban,
          titulaire_compte: titulaire_compte,
          reference: reference,
          remise_sma: remise_sma,
        }
      })

      return request.authorize().exec()
        .then(({ mandate_reference, payment_id, price }) => {
          this.$patch({ payment_id, mandate: mandate_reference, price })
        })
    },

    /**
     * @function validation - Confirms SEPA payment, if successful payment is validated
     * @param {object} options
     * @param {string} options.payment_id
     * @param {import('~/stores/client/access').Structure["code_client"]} options.code
     * @return {Promise<{ ok: boolean, message?: string, paymentData: import('~/stores/hamac/signatures/infos').PaymentData }>}
     */
    validation({ payment_id, code }) {
      // @NOTE Evaluates to true only when environment is prod
      const real_payment = import.meta.env.VITE_ENVIRONMENT === 'production'

      const route = concatAll([
        `/paiements/sepa`,
        `/code/${code}`,
        `/validation/${payment_id}?real_payment=${real_payment}`,
      ])

      const request = new Request({
        method: 'get',
        route,
      })

      return request.authorize().exec()
    },

    /**
     * @function checkPayment @XXX Same as cic checkPayment because no route exist to check payment only for sepa
     * @param {object} options
     * @param {import('~/stores/client/access').Structure["code_client"]} options.code
     * @param {string} options.payment_id // Payment id
     * @return {Promise<{ ok?: boolean, message?: string, paymentData?: import('~/stores/hamac/signatures/infos').PaymentData }>}
    */
    checkPayment({ code, payment_id }) {
      const route = concatAll([
        `/paiements`,
        `/code/${code}`,
        `/check_payment/cic/${payment_id}`,
      ])

      const request = new Request({
        method: 'get',
        route,
      })

      return request.authorize().exec()
    }
  }
})

